var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"policy-eng"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"md-6"}},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"search-options":{
  enabled: true
}},on:{"on-row-click":_vm.onRowClick}})],1),_c('b-col',{attrs:{"cols":"md-6"}},[_c('div',{attrs:{"id":"info-box-eng"}},[_vm._v("Click the row to read the clause descriptions.")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }